import * as types from "../actions/types/paymentRequest.types";

const initialState = {
  getAllApprovals: null,
  getAllApprovalsState: "",
  getAllApprovalsLoading: false,
  approveTransactionsLoading: false,
  approveTransactionsState: "",
  loadMoreState: "idle",
};

export const paymentRequestReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.GET_APPROVALS_SUCCEEDED:
        return {
          ...state,
          getAllApprovalsState: "success",
          getAllApprovals: action.payload,
          getAllApprovalsLoading: action.loading,
        };
      case types.GET_APPROVALS_FAILED:
        return {
          ...state,
          getAllApprovalsState: "failed",
          getAllApprovalsLoading: action.loading,
        };
      case types.GET_APPROVALS_DEFAULT:
        return {
          ...state,
          getAllApprovalsState: "",
        };
      case types.GET_APPROVALS_LOADING:
        return {
          ...state,
          getAllApprovalsLoading: action.loading,
          getAllApprovalsState: "loading",
        };
      case types.APPROVE_TRANSACTIONS_LOADING:
        return {
          ...state,
          approveTransactionsLoading: action.loading,
        };
      case types.APPROVE_TRANSACTIONS_SUCCEEDED:
        return {
          ...state,
          approveTransactionsState: "success",
          approveTransactionsLoading: action.loading,
        };
      case types.APPROVE_TRANSACTIONS_FAILED:
        return {
          ...state,
          approveTransactionsState: "failed",
          approveTransactionsLoading: action.loading,
        };

      case types.LOAD_MORE_APPROVALS_STARTED:
        return {
          ...state,
          loadMoreState: "loading",
        };
      case types.LOAD_MORE_APPROVALS_SUCCEEDED:
        return {
          ...state,
          loadMoreState: "success",
          getAllApprovals: state.getAllApprovals.concat(action.payload),
        };
      case types.LOAD_MORE_APPROVALS_FAILED:
        return {
          ...state,
          loadMoreState: "failed",
          errorMessage: action.payload.message,
        };
      default:
        return state;
    }
};
